import React, { useMemo, useState } from 'react';
import { Calculator, Package } from 'lucide-react';
import Navbar from '../components/Navbar';

export default function MaterialCalculator() {
  const [mode, setMode] = useState('wall');
  const [length, setLength] = useState(20);
  const [height, setHeight] = useState(10);
  const [thickness, setThickness] = useState(9);
  const [area, setArea] = useState(1000);

  const result = useMemo(() => {
    if (mode === 'slab') {
      const cementBags = Math.ceil(area * 0.08);
      const sandCft = Math.ceil(area * 0.45);
      const steelKg = Math.ceil(area * 3.5);
      return [
        ['Cement', `${cementBags} bags`],
        ['Sand', `${sandCft} cft`],
        ['Steel', `${steelKg} kg`],
      ];
    }
    const wallArea = Number(length || 0) * Number(height || 0);
    const brickCount = Math.ceil(wallArea * (Number(thickness) >= 9 ? 9 : 4.5));
    const cementBags = Math.ceil(brickCount / 500);
    const sandCft = Math.ceil(brickCount * 0.045);
    return [
      ['Bricks', `${brickCount.toLocaleString()} pcs`],
      ['Cement', `${cementBags} bags`],
      ['Sand', `${sandCft} cft`],
    ];
  }, [mode, length, height, thickness, area]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--page-bg)' }}>
      <Navbar />
      <main style={{ maxWidth: 900, margin: '0 auto', padding: '28px 16px' }}>
        <div style={{ background: 'white', borderRadius: 14, padding: 20, boxShadow: 'var(--shadow)' }}>
          <h1 style={{ fontSize: 24, fontWeight: 900, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            <Calculator size={22} color="var(--orange)" /> Material Calculator
          </h1>
          <p style={{ color: 'var(--gray)', fontSize: 14, marginBottom: 18 }}>Estimate common construction material quantities before ordering.</p>

          <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
            {[
              ['wall', 'Wall'],
              ['slab', 'Slab / Roof'],
            ].map(([key, label]) => (
              <button key={key} onClick={() => setMode(key)}
                style={{ flex: 1, padding: '10px', borderRadius: 10, border: `1.5px solid ${mode === key ? 'var(--orange)' : 'var(--gray-border)'}`, background: mode === key ? 'var(--orange-soft)' : 'white', color: mode === key ? 'var(--orange)' : 'var(--dark)', fontWeight: 800 }}>
                {label}
              </button>
            ))}
          </div>

          {mode === 'wall' ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: 12 }}>
              <label><span className="form-label">Length in feet</span><input className="form-input" type="number" value={length} onChange={e => setLength(e.target.value)} /></label>
              <label><span className="form-label">Height in feet</span><input className="form-input" type="number" value={height} onChange={e => setHeight(e.target.value)} /></label>
              <label><span className="form-label">Thickness in inches</span><input className="form-input" type="number" value={thickness} onChange={e => setThickness(e.target.value)} /></label>
            </div>
          ) : (
            <label><span className="form-label">Slab area in sq.ft</span><input className="form-input" type="number" value={area} onChange={e => setArea(e.target.value)} /></label>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: 12, marginTop: 20 }}>
            {result.map(([label, value]) => (
              <div key={label} style={{ background: 'var(--gray-light)', borderRadius: 12, padding: 14 }}>
                <Package size={17} color="var(--orange)" />
                <div style={{ fontSize: 12, color: 'var(--gray)', marginTop: 8 }}>{label}</div>
                <div style={{ fontSize: 22, fontWeight: 900 }}>{value}</div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
